import { InjectionToken } from '@angular/core';
import { AppLanguage } from '../services/language.service';
import { AppCurrency } from '../types/currency';

export const APP_CONFIG = new InjectionToken('APP_CONFIG', {
  factory: () => _appConfig,
});

export interface AppConfig {
  fieldValidation: {
    email: {
      pattern: RegExp;
    };
    username: {
      minLength: number;
      pattern: RegExp;
    };
    password: {
      minLength: number;
      pattern: RegExp;
    };
    fullname: {
      minLength: number;
      pattern: RegExp;
    };
  };
  shippingPrice: number;
  stopReceivingOrdersAt: number; // hour of the day in 24-format
  privacyPolicyUrls: Record<AppLanguage, string>;
  contactEmail: string;
  contactPhone: string;
  features: {
    deliveryEnabled: boolean;
    creditCardEnabled: boolean;
  };
  instorePurchases: {
    sessionLength: number; // in ms
  };
  imprint: {
    companyName: Record<AppLanguage, string>;
    companyAddress: Record<AppLanguage, string>;
    bulstat: string;
    taxNumber: string;
    responsiblePerson: Record<AppLanguage, string>;
    coreWebsite: string;
  };
  supportedCurrencies: AppCurrency[];
  mainCurrency: AppCurrency;
  eurToLevaFixedRate: number;
}

const _appConfig: AppConfig = {
  fieldValidation: {
    email: {
      pattern: /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
    },
    username: {
      minLength: 5,
      pattern: /[a-zA-Z0-9_]*/,
    },
    password: {
      minLength: 8,
      pattern: /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/,
    },
    fullname: {
      minLength: 3,
      pattern: /[a-zA-Zа-яА-Я\-\'\ ]*/,
    },
  },
  shippingPrice: 190,
  stopReceivingOrdersAt: 12,
  privacyPolicyUrls: {
    en: 'https://chillandbite.com/en/privacy-policy-en/',
    bg: 'https://chillandbite.com/privacy-policy/',
  },
  contactEmail: 'info@chillandbite.com',
  contactPhone: '+359888887698',
  features: {
    deliveryEnabled: false,
    creditCardEnabled: true,
  },
  instorePurchases: {
    sessionLength: 300_000,
  },
  imprint: {
    companyName: {
      en: 'Health in Box Ltd',
      bg: 'Хелт ин Бокс ООД',
    },
    companyAddress: {
      en: '24 Shabanitsa St., 1806, Gorni Bogrov, Bulgaria',
      bg: 'ул. "Шабаница" 24, 1806, Горни Богров, България',
    },
    bulstat: '206247237',
    taxNumber: 'BG206247237',
    responsiblePerson: {
      en: ' Ivaylo Nikolov',
      bg: 'Ивайло Николов',
    },
    coreWebsite: 'https://chillandbite.com',
  },
  supportedCurrencies: [AppCurrency.BGN, AppCurrency.EUR],
  mainCurrency: AppCurrency.EUR,
  eurToLevaFixedRate: 1.95583,
};
